var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter_legend_wrapper"},[_c('legend',{staticClass:"filter_legend"},[_vm._v(" "+_vm._s(_vm.legend)+" ")]),(_vm.show)?_c('div',{staticClass:"filter_legend__clear",on:{"click":_vm.clear}},[_c('v-icon',{staticClass:"x",attrs:{"size":"20"}},[_vm._v("fa-trash")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }